import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/settings/referrals")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/settings/subscription/referrals" replace />
}
